import React from 'react';
import Header from '../Header';
import NotAvailablePanel from '../NotAvailablePanel';
import { useVisualType, type VisualType } from '../hooks/useVisualType';
import {useAvailable} from '../hooks/useAvailable';
import type { CommonTypes } from '../helpers';

interface WidgetPanelProps extends Pick<CommonTypes, 'enableSSF' | 'enableTimeSlice'> {
  title: string;
  children: ({ stacked, treemap, chartType }: { stacked: boolean; treemap: boolean; chartType: VisualType }) => React.ReactNode;
}

const WidgetPanel = ({ title, enableSSF, enableTimeSlice, children }: WidgetPanelProps) => {
  const validate = useAvailable(enableSSF, enableTimeSlice);
  const { stacked, treemap, enableMetricFilter, message } = validate
  const [chartType, setChartType] = useVisualType();
  return (
    <div>
      <Header title={`${enableMetricFilter ? '[SF] ' : ''}${title}`} value={chartType} onChange={setChartType} validate={validate} />
      {children({ stacked, treemap, chartType })}
      {!(chartType === 'stacked' ? stacked : treemap) && <NotAvailablePanel message={message[chartType]} />}
    </div>
  )
}

export default WidgetPanel;
